export const countriesList = [
    {code:"AF",name:"Afghanistan"},
    {code:"AL",name:"Albania"},
    {code:"DZ",name:"Algeria"},
    {code:"AS",name:"American Samoa"},
    {code:"AD",name:"Andorra"},
    {code:"AO",name:"Angola"},
    {code:"AI",name:"Anguilla"},
    {code:"AQ",name:"Antarctica"},
    {code:"AG",name:"Antigua and Barbuda"},
    {code:"AR",name:"Argentina"},
    {code:"AM",name:"Armenia"},
    {code:"AW",name:"Aruba"},
    {code:"AU",name:"Australia"},
    {code:"AT",name:"Austria"},
    {code:"AZ",name:"Azerbaijan"},
    {code:"BS",name:"Bahamas"},
    {code:"BH",name:"Bahrain"},
    {code:"BD",name:"Bangladesh"},
    {code:"BB",name:"Barbados"},
    {code:"BY",name:"Belarus"},
    {code:"BE",name:"Belgium"},
    {code:"BZ",name:"Belize"},
    {code:"BJ",name:"Benin"},
    {code:"BM",name:"Bermuda"},
    {code:"BT",name:"Bhutan"},
    {code:"BO",name:"Bolivia, Plurinational State of"},
    {code:"BA",name:"Bosnia and Herzegovina"},
    {code:"BW",name:"Botswana"},
    {code:"BR",name:"Brazil"},
    {code:"IO",name:"British Indian Ocean Territory"},
    {code:"BN",name:"Brunei Darussalam"},
    {code:"BG",name:"Bulgaria"},
    {code:"BF",name:"Burkina Faso"},
    {code:"BI",name:"Burundi"},
    {code:"KH",name:"Cambodia"},
    {code:"CM",name:"Cameroon"},
    {code:"CA",name:"Canada"},
    {code:"CV",name:"Cape Verde"},
    {code:"KY",name:"Cayman Islands"},
    {code:"CF",name:"Central African Republic"},
    {code:"TD",name:"Chad"},
    {code:"CL",name:"Chile"},
    {code:"CN",name:"China"},
    {code:"CX",name:"Christmas Island"},
    {code:"CO",name:"Colombia"},
    {code:"KM",name:"Comoros"},
    {code:"CG",name:"Congo"},
    {code:"CD",name:"Congo, the Democratic Republic of the"},
    {code:"CK",name:"Cook Islands"},
    {code:"CR",name:"Costa Rica"},
    {code:"HR",name:"Croatia"},
    {code:"CU",name:"Cuba"},
    {code:"CY",name:"Cyprus"},
    {code:"CZ",name:"Czech Republic"},
    {code:"CI",name:"Côte d'Ivoire"},
    {code:"DK",name:"Denmark"},
    {code:"DJ",name:"Djibouti"},
    {code:"DM",name:"Dominica"},
    {code:"DO",name:"Dominican Republic"},
    {code:"EC",name:"Ecuador"},
    {code:"EG",name:"Egypt"},
    {code:"SV",name:"El Salvador"},
    {code:"GQ",name:"Equatorial Guinea"},
    {code:"ER",name:"Eritrea"},
    {code:"EE",name:"Estonia"},
    {code:"ET",name:"Ethiopia"},
    {code:"FK",name:"Falkland Islands (Malvinas)"},
    {code:"FO",name:"Faroe Islands"},
    {code:"FJ",name:"Fiji"},
    {code:"FI",name:"Finland"},
    {code:"FR",name:"France"},
    {code:"GF",name:"French Guiana"},
    {code:"PF",name:"French Polynesia"},
    {code:"GA",name:"Gabon"},
    {code:"GM",name:"Gambia"},
    {code:"GE",name:"Georgia"},
    {code:"DE",name:"Germany"},
    {code:"GH",name:"Ghana"},
    {code:"GI",name:"Gibraltar"},
    {code:"GR",name:"Greece"},
    {code:"GL",name:"Greenland"},
    {code:"GD",name:"Grenada"},
    {code:"GP",name:"Guadeloupe"},
    {code:"GU",name:"Guam"},
    {code:"GT",name:"Guatemala"},
    {code:"GG",name:"Guernsey"},
    {code:"GN",name:"Guinea"},
    {code:"GW",name:"Guinea-Bissau"},
    {code:"GY",name:"Guyana"},
    {code:"HT",name:"Haiti"},
    {code:"VA",name:"Holy See (Vatican City State)"},
    {code:"HN",name:"Honduras"},
    {code:"HK",name:"Hong Kong"},
    {code:"HU",name:"Hungary"},
    {code:"IS",name:"Iceland"},
    {code:"IN",name:"India"},
    {code:"ID",name:"Indonesia"},
    {code:"IR",name:"Iran, Islamic Republic of"},
    {code:"IQ",name:"Iraq"},
    {code:"IE",name:"Ireland"},
    {code:"IL",name:"Israel"},
    {code:"IT",name:"Italy"},
    {code:"JM",name:"Jamaica"},
    {code:"JP",name:"Japan"},
    {code:"JE",name:"Jersey"},
    {code:"JO",name:"Jordan"},
    {code:"KZ",name:"Kazakhstan"},
    {code:"KE",name:"Kenya"},
    {code:"KI",name:"Kiribati"},
    {code:"KP",name:"Korea, Democratic People's Republic of"},
    {code:"KR",name:"Korea, Republic of"},
    {code:"XK",name:"Kosovo, Republic of"},
    {code:"KW",name:"Kuwait"},
    {code:"KG",name:"Kyrgyzstan"},
    {code:"LA",name:"Lao People's Democratic Republic"},
    {code:"LV",name:"Latvia"},
    {code:"LB",name:"Lebanon"},
    {code:"LS",name:"Lesotho"},
    {code:"LR",name:"Liberia"},
    {code:"LY",name:"Libya"},
    {code:"LI",name:"Liechtenstein"},
    {code:"LT",name:"Lithuania"},
    {code:"LU",name:"Luxembourg"},
    {code:"MO",name:"Macao"},
    {code:"MK",name:"Macedonia, the former Yugoslav Republic of"},
    {code:"MG",name:"Madagascar"},
    {code:"MW",name:"Malawi"},
    {code:"MY",name:"Malaysia"},
    {code:"MV",name:"Maldives"},
    {code:"ML",name:"Mali"},
    {code:"MT",name:"Malta"},
    {code:"MH",name:"Marshall Islands"},
    {code:"MQ",name:"Martinique"},
    {code:"MR",name:"Mauritania"},
    {code:"MU",name:"Mauritius"},
    {code:"YT",name:"Mayotte"},
    {code:"MX",name:"Mexico"},
    {code:"FM",name:"Micronesia, Federated States of"},
    {code:"MD",name:"Moldova, Republic of"},
    {code:"MC",name:"Monaco"},
    {code:"MN",name:"Mongolia"},
    {code:"ME",name:"Montenegro"},
    {code:"MS",name:"Montserrat"},
    {code:"MA",name:"Morocco"},
    {code:"MZ",name:"Mozambique"},
    {code:"MM",name:"Myanmar"},
    {code:"NA",name:"Namibia"},
    {code:"NR",name:"Nauru"},
    {code:"NP",name:"Nepal"},
    {code:"NL",name:"Netherlands"},
    {code:"AN",name:"Netherlands Antilles"},
    {code:"NC",name:"New Caledonia"},
    {code:"NZ",name:"New Zealand"},
    {code:"NI",name:"Nicaragua"},
    {code:"NE",name:"Niger"},
    {code:"NG",name:"Nigeria"},
    {code:"NU",name:"Niue"},
    {code:"NF",name:"Norfolk Island"},
    {code:"MP",name:"Northern Mariana Islands"},
    {code:"NO",name:"Norway"},
    {code:"OM",name:"Oman"},
    {code:"PK",name:"Pakistan"},
    {code:"PW",name:"Palau"},
    {code:"PS",name:"Palestine, State of"},
    {code:"PA",name:"Panama"},
    {code:"PG",name:"Papua New Guinea"},
    {code:"PY",name:"Paraguay"},
    {code:"PE",name:"Peru"},
    {code:"PH",name:"Philippines"},
    {code:"PN",name:"Pitcairn"},
    {code:"PL",name:"Poland"},
    {code:"PT",name:"Portugal"},
    {code:"PR",name:"Puerto Rico"},
    {code:"QA",name:"Qatar"},
    {code:"RO",name:"Romania"},
    {code:"RU",name:"Russian Federation"},
    {code:"RW",name:"Rwanda"},
    {code:"RE",name:"Réunion"},
    {code:"SH",name:"Saint Helena, Ascension and Tristan da Cunha"},
    {code:"KN",name:"Saint Kitts and Nevis"},
    {code:"LC",name:"Saint Lucia"},
    {code:"PM",name:"Saint Pierre and Miquelon"},
    {code:"VC",name:"Saint Vincent and the Grenadines"},
    {code:"WS",name:"Samoa"},
    {code:"SM",name:"San Marino"},
    {code:"SA",name:"Saudi Arabia"},
    {code:"SN",name:"Senegal"},
    {code:"RS",name:"Serbia"},
    {code:"SC",name:"Seychelles"},
    {code:"SL",name:"Sierra Leone"},
    {code:"SG",name:"Singapore"},
    {code:"SK",name:"Slovakia"},
    {code:"SI",name:"Slovenia"},
    {code:"SB",name:"Solomon Islands"},
    {code:"SO",name:"Somalia"},
    {code:"ZA",name:"South Africa"},
    {code:"GS",name:"South Georgia and the South Sandwich Islands"},
    {code:"SS",name:"South Sudan"},
    {code:"ES",name:"Spain"},
    {code:"LK",name:"Sri Lanka"},
    {code:"SD",name:"Sudan"},
    {code:"SR",name:"Suriname"},
    {code:"SJ",name:"Svalbard and Jan Mayen"},
    {code:"SZ",name:"Swaziland"},
    {code:"SE",name:"Sweden"},
    {code:"CH",name:"Switzerland"},
    {code:"SY",name:"Syrian Arab Republic"},
    {code:"ST",name:"São Tomé and Príncipe"},
    {code:"TW",name:"Taiwan"},
    {code:"TJ",name:"Tajikistan"},
    {code:"TZ",name:"Tanzania, United Republic of"},
    {code:"TH",name:"Thailand"},
    {code:"TL",name:"Timor-Leste"},
    {code:"TG",name:"Togo"},
    {code:"TK",name:"Tokelau"},
    {code:"TO",name:"Tonga"},
    {code:"TT",name:"Trinidad and Tobago"},
    {code:"TN",name:"Tunisia"},
    {code:"TR",name:"Turkey"},
    {code:"TM",name:"Turkmenistan"},
    {code:"TC",name:"Turks and Caicos Islands"},
    {code:"TV",name:"Tuvalu"},
    {code:"UG",name:"Uganda"},
    {code:"UA",name:"Ukraine"},
    {code:"AE",name:"United Arab Emirates"},
    {code:"GB",name:"United Kingdom"},
    {code:"US",name:"United States"},
    {code:"UM",name:"United States Minor Outlying Islands"},
    {code:"UY",name:"Uruguay"},
    {code:"UZ",name:"Uzbekistan"},
    {code:"VU",name:"Vanuatu"},
    {code:"VE",name:"Venezuela, Bolivarian Republic of"},
    {code:"VN",name:"Viet Nam"},
    {code:"VG",name:"Virgin Islands, British"},
    {code:"VI",name:"Virgin Islands, U.S."},
    {code:"WF",name:"Wallis and Futuna"},
    {code:"EH",name:"Western Sahara"},
    {code:"YE",name:"Yemen"},
    {code:"ZM",name:"Zambia"},
    {code:"ZW",name:"Zimbabwe"},
    {code:"AX",name:"Åland Islands"}
    ]

export const numberList = {US:"1",AG:"1",AI:"1",AS:"1",BB:"1",BM:"1",BS:"1",CA:"1",DM:"1",DO:"1",GD:"1",GU:"1",JM:"1",KN:"1",KY:"1",LC:"1",MP:"1",MS:"1",PR:"1",SX:"1",TC:"1",TT:"1",VC:"1",VG:"1",VI:"1",RU:"7",KZ:"7",EG:"20",ZA:"27",GR:"30",NL:"31",BE:"32",FR:"33",ES:"34",HU:"36",IT:"39",VA:"39",RO:"40",CH:"41",AT:"43",GB:"44",GG:"44",IM:"44",JE:"44",DK:"45",SE:"46",NO:"47",SJ:"47",PL:"48",DE:"49",PE:"51",MX:"52",CU:"53",AR:"54",BR:"55",CL:"56",CO:"57",VE:"58",MY:"60",AU:"61",CC:"61",CX:"61",ID:"62",PH:"63",NZ:"64",SG:"65",TH:"66",JP:"81",KR:"82",VN:"84",CN:"86",TR:"90",IN:"91",PK:"92",AF:"93",LK:"94",MM:"95",IR:"98",SS:"211",MA:"212",EH:"212",DZ:"213",TN:"216",LY:"218",GM:"220",SN:"221",MR:"222",ML:"223",GN:"224",CI:"225",BF:"226",NE:"227",TG:"228",BJ:"229",MU:"230",LR:"231",SL:"232",GH:"233",NG:"234",TD:"235",CF:"236",CM:"237",CV:"238",ST:"239",GQ:"240",GA:"241",CG:"242",CD:"243",AO:"244",GW:"245",IO:"246",AC:"247",SC:"248",SD:"249",RW:"250",ET:"251",SO:"252",DJ:"253",KE:"254",TZ:"255",UG:"256",BI:"257",MZ:"258",ZM:"260",MG:"261",RE:"262",YT:"262",ZW:"263",NA:"264",MW:"265",LS:"266",BW:"267",SZ:"268",KM:"269",SH:"290",TA:"290",ER:"291",AW:"297",FO:"298",GL:"299",GI:"350",PT:"351",LU:"352",IE:"353",IS:"354",AL:"355",MT:"356",CY:"357",FI:"358",AX:"358",BG:"359",LT:"370",LV:"371",EE:"372",MD:"373",AM:"374",BY:"375",AD:"376",MC:"377",SM:"378",UA:"380",RS:"381",ME:"382",XK:"383",HR:"385",SI:"386",BA:"387",MK:"389",CZ:"420",SK:"421",LI:"423",FK:"500",BZ:"501",GT:"502",SV:"503",HN:"504",NI:"505",CR:"506",PA:"507",PM:"508",HT:"509",GP:"590",BL:"590",MF:"590",BO:"591",GY:"592",EC:"593",GF:"594",PY:"595",MQ:"596",SR:"597",UY:"598",CW:"599",BQ:"599",TL:"670",NF:"672",BN:"673",NR:"674",PG:"675",TO:"676",SB:"677",VU:"678",FJ:"679",PW:"680",WF:"681",CK:"682",NU:"683",WS:"685",KI:"686",NC:"687",TV:"688",PF:"689",TK:"690",FM:"691",MH:"692","001":"979",KP:"850",HK:"852",MO:"853",KH:"855",LA:"856",BD:"880",TW:"886",MV:"960",LB:"961",JO:"962",SY:"963",IQ:"964",KW:"965",SA:"966",YE:"967",OM:"968",PS:"970",AE:"971",IL:"972",BH:"973",QA:"974",BT:"975",MN:"976",NP:"977",TJ:"992",TM:"993",AZ:"994",GE:"995",KG:"996",UZ:"998",GS:"500",PN:"64",AQ:"672",UM:"1",AN:"599"}
